<template>
  <div class="card">
    <div class="content inset">
      <!-- Klantkoppeling -->
      <h2 class="title">
        <awesomeIcon icon="user-tag"/>
        Klantkoppeling <i style="font-size: 15px">(Dit scherm is niet zichtbaar voor de klant)</i>
      </h2>
      <div :class="['msg', 'icon', 'warning']">
        <div class="icon">
          <awesomeIcon icon="info-circle"/>
        </div>
        Als u deze vragenlijst aan uw klant koppelt ontvangt uw klant een e-mail om u te
        machtigen. Totdat de klant deze heeft geaccepteerd kunt u de vragenlijst niet verder
        bewerken. Wilt u vooraf gegevens voor uw klant invullen? Doe dit dan eerst en koppel dan pas
        uw klant via dit scherm.
        <template v-if="modelValue.atpData.connected">
          <br /><br />
          <b>De vragenlijst is reeds gekoppeld aan {{ modelValue.atpData.email }}.</b>
        </template>
      </div>
      <p>
        Om de koppeling tot stand te brengen vult u onderstaande gegevens in. Daarnaast kunt u hier
        aangeven of uw kosten geïncasseerd worden via de beleggingsrekening bij Doelbeleggen.
      </p>
      <div class="flex-container flex-grow" style="margin-top: 20px">
        <customInput
          type="dropdown"
          v-model="modelValue.persoonsData[0].geslacht"
          :label="'Geslacht'"
          :options="[
            {label:'Vrouw', value:'vrouw'},
            {label:'Man', value:'man'},
          ]"
        />
        <customInput
          type="text"
          label="Roepnaam"
          placeholder="Vul hier de roepnaam van de klant in"
          v-model="modelValue.persoonsData[0].roepnaam"
        />
      </div>
      <div class="flex-container flex-grow">
        <customInput
          type="text"
          label="Tussenvoegsel"
          v-model="modelValue.persoonsData[0].tussenvoegsel"
          :validation="['notrequired']"
          class="flex-grow-half flex-50"
        />
        <customInput
          type="text"
          class="flex-50"
          label="Achternaam"
          placeholder="Zoals in deze persoon zijn paspoort of ID-kaart"
          v-model="modelValue.persoonsData[0].achternaam"
        />
        <customInput
          v-model="modelValue.atpData.email"
          type="text"
          class="flex-50"
          label="E-mailadres"
          placeholder="Vul hier het e-mailadres van de klant in"
          :validation="['email']"
          :disabled="modelValue.atpData.connected"
        />
        <customInput
          class="flex-50"
          v-model="modelValue.persoonsData[0].geboorteDatum"
          type="date"
          label="Geboortedatum"
          :maxDatetime="new Date()"
          :validation="['max']"
        />
      </div>
      <p>
        <template v-if="modelValue.atpData.connected">
          Uw kosten worden geïncasseerd via de beleggingsrekening bij Doelbeleggen
        </template>
        <template v-else>
          Uw kosten kunnen geïncasseerd worden via de beleggingsrekening bij Doelbeleggen.
        </template>
        Uw klant ontvang hiervoor een machtiging ter ondertekening. Wij zullen uw kosten op de
        rekening van de klant incasseren aan het einde van de maand waarop het eerste kapitaal is
        ontvangen.
      </p>
      <customInput
        v-if="!modelValue.atpData.connected"
        style="margin-top: 10px"
        v-model="modelValue.atpData.kosten"
        type="yesno"
        label="Wilt u dat uw kosten geïncasseerd worden via de beleggingsrekening bij Doelbeleggen?"
      />
      <div
        v-if="modelValue.atpData.kosten == 'Yes'"
      >
        <customInput
          v-model="modelValue.atpData.vergoedingEenmalig"
          type="money"
          label="Vergoeding eenmalig"
          placeholder="€"
          :validation="['notrequired']"
          :disabled="modelValue.atpData.connected"
        />
        <customInput
          v-model="modelValue.atpData.vergoedingJaar"
          type="money"
          label="Vergoeding per jaar (€)"
          :validation="['notrequired']"
          placeholder="€"
          :disabled="modelValue.atpData.connected"
        />
        <customInput
          v-model="modelValue.atpData.vergoedingPercentageJaar"
          type="percentage"
          :validation="['notrequired']"
          label="Vergoeding per jaar (%)"
          :disabled="modelValue.atpData.connected"
        />
      </div>
      <div class="row" style="margin-top: 10px">
        <button
          v-if="!modelValue.atpData.connected"
          style="float:right; width: 200px;"
          @click="connectUserToIntake"
        >
          Koppel klant
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConnectClient',
  emits: ['update:model-value'],
  props: {
    modelValue: Object,
  },
  methods: {
    connectUserToIntake() {
      if (!this.modelValue.persoonsData[0].roepnaam
        || !this.modelValue.persoonsData[0].achternaam
        || !this.modelValue.persoonsData[0].geslacht) {
        this.$store.state.confirm.toggle({
          alert: true,
          text: 'Vul de roepnaam, het geslacht en de achternaam van de klant in',
          cb: () => {},
        });
        return;
      }
      this.$parent.validationAlert();
      if (this.modelValue.atpData.email) {
        const re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/g;
        if (!re.test(this.modelValue.atpData.email)) {
          this.$store.state.confirm.toggle({
            alert: true,
            text: 'Vul een correct e-mailadres in',
            cb: () => {},
          });
        } else if (!this.modelValue.atpData.kosten) {
          this.$store.state.confirm.toggle({
            alert: true,
            text: 'Geef aan of u de kosten geïncasseerd wilt hebben via de beleggingsrekening bij Doelbeleggen ',
            cb: () => {},
          });
        } else if (
          !this.modelValue.persoonsData[0].geboorteDatum
          || new Date(this.modelValue.persoonsData[0].geboorteDatum) >= new Date()
        ) {
          this.$store.state.confirm.toggle({
            alert: true,
            text: 'De geboortedatum is incorrect',
            cb: () => {},
          });
        } else {
          this.modelValue.atpData.connected = true;
          this.$parent.storeIntake(this.modelValue.step);
          this.sdk.linkIntakeUserAtp(
            this.getQueryVariable('intake'),
            this.modelValue.atpData.email,
            `${this.modelValue.persoonsData[0].roepnaam || ''} ${this.modelValue.persoonsData[0].tussenvoegsel || ''} ${this.modelValue.persoonsData[0].achternaam}`,
            this.modelValue.persoonsData[0].geslacht === 'man' ? 'heer' : 'mevrouw',
            (response) => {
              if (response.status === 200) {
                window.onbeforeunload = () => {};
                window.location.href = '?';
              } else if (response.status === 406) {
                this.modelValue.atpData.connected = false;
                this.$parent.storeIntake(this.modelValue.step);
                this.modelValue.atpData.email = '';
                this.$store.state.confirm.toggle({
                  alert: true,
                  text: 'U kunt de vragenlijst niet koppelen aan uzelf. U kunt deze alleen koppelen aan uw klant.',
                  cb: () => {},
                });
              } else if (response.status === 404) {
                this.modelValue.atpData.connected = false;
                this.$parent.storeIntake(this.modelValue.step);
                this.$store.state.confirm.toggle({
                  alert: true,
                  text: 'Vul eerst alle gegevens in door links in het dashboard op \'Mijn informatie\' te klikken.',
                  cb: () => {},
                });
              } else if (response.status === 403) {
                this.modelValue.atpData.connected = false;
                this.$parent.storeIntake(this.modelValue.step);
                this.$store.state.confirm.toggle({
                  alert: true,
                  text: 'U bent geen adviseur van deze vragenlijst.',
                  cb: () => {},
                });
              }
            },
          );
        }
      }
    },
  },
};
</script>
